import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { omit } from "lodash";
import { setIsLoading } from "../../../actions/common";
import {setSearchLoader} from "../../../actions/common";
import { loginPageUrl, storeTokenParams, clearStoredTokenParams, isTokenExpired, buildQueryStringForRefreshingToken } from "../functions/auth";
import { getSelectedCountryCode, getSubCommunities, getSelectedSubCommunity } from "../functions/countrySetting";

const WithAjax = (WrappedComponent) => {
  return class extends Component {
    constructor() {
      super();
      this.post = this.post.bind(this);
      this.put = this.put.bind(this);
      this.get = this.get.bind(this);
      this.getPromise = this.getPromise.bind(this);
      this.deletePromise = this.deletePromise.bind(this);
      this.delete = this.delete.bind(this);
      this.tokenPost = this.tokenPost.bind(this);
      this.getImageAsBlob = this.getImageAsBlob.bind(this);
      this.removeLoaderMask = this.removeLoaderMask.bind(this);
    }



    post(url, body, optionalInit, onSuccess , searchLoader=false) {
      let init = {}
      if(optionalInit !== null  && getSubCommunities() && getSelectedSubCommunity()){
        optionalInit.headers = {
          'ProdubSubcommunity':(getSelectedSubCommunity()),
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
        init = {
        ...optionalInit,
        ...{
          method: "POST",
        },
       };
      }
      if(optionalInit == null  && getSubCommunities() && getSelectedSubCommunity()){
        let initSubcommunity = {}
        initSubcommunity.headers = {
          'ProdubSubcommunity':(getSelectedSubCommunity())
        };
        init = {
        ...initSubcommunity,
        ...{
          method: "POST",
        },
       };
      }
      if(getSubCommunities() && getSelectedCountryCode() !== 'be'){
        init = {
        ...optionalInit,
        ...{
          method: "POST",
        }
      }
      }
      if(!getSubCommunities()){
        init = {
        ...optionalInit,
        ...{
          method: "POST",
        }
      }
      }




      if (searchLoader) {
        this.props.setIsLoading(false);
        this.props.setSearchLoader(true);
      } else {
        this.props.setIsLoading(true);
      }
      this.useAccessToken(init).then((init) => {
        this.postPut(this.buildFullUrl(url, true), body, init, onSuccess);
      });
    }

    delete(url, body, optionalInit, onSuccess) {
      let init = {
        ...optionalInit,
        ...{
          method: "DELETE",
        },
      };

      this.props.setIsLoading(true);
      this.useAccessToken(init).then((init) => {
        this.postPut(this.buildFullUrl(url, true), body, init, onSuccess);
      });
    }

    deletePromise(url, body, optionalInit) {
      let init = {
        ...optionalInit,
        ...{
          method: "DELETE",
        },
      };

      return this.useAccessToken(init).then((init) => {
        return fetch(this.buildFullUrl(url, true), init);
      });
    }

    put(url, body, optionalInit, onSuccess) {
      let init = {}
      if(optionalInit !== null  && getSubCommunities() && getSelectedSubCommunity()){
        optionalInit.headers = {
          'ProdubSubcommunity':(getSelectedSubCommunity()),
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
        init = {
        ...optionalInit,
        ...{
          method: "PUT",
        },
       };
      }
      if(optionalInit == null && getSubCommunities() && getSelectedSubCommunity()){
        let initSubcommunity = {}
        initSubcommunity.headers = {
          'ProdubSubcommunity':getSelectedSubCommunity()
        };
        init = {
        ...initSubcommunity,
        ...{
          method: "PUT",
        },
       };
      }
      if(getSubCommunities() && getSelectedCountryCode() !== 'be'){
        init = {
        ...optionalInit,
        ...{
          method: "PUT",
        }
      }
      }
      if(!getSubCommunities()){
        init = {
        ...optionalInit,
        ...{
          method: "PUT",
        }
      }
      }



      this.props.setIsLoading(true);
      this.useAccessToken(init).then((init) => {
        this.postPut(this.buildFullUrl(url, true), body, init, onSuccess);
      });
    }

    get(url, includeCountryCode, onSuccess, interval = false, searchLoader = false) {
      let init = {};
      if(getSubCommunities() !== '' && getSelectedSubCommunity()){
        init.headers = {'ProdubSubcommunity':(getSelectedSubCommunity())}
      }
      if (interval || searchLoader) {
        this.props.setIsLoading(false);
      } else {
        this.props.setIsLoading(true);
      }

      this.useAccessToken(init).then((init) => {
        fetch(this.buildFullUrl(url, includeCountryCode), init)
          .then((response) => {
            if (response.status === 401) {
              this.props.history.push(loginPageUrl);
            }

            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
              return response.json();
            } else {
              return response;
            }
          })
          .then((data) => {
            if (onSuccess) {
              onSuccess(data);
            }
            if (!interval) {
              this.props.setIsLoading(false);
            }
          })
          .catch((error) => {
            this.removeLoaderMask(interval);
          });
      });
    }

    getPromise(url, includeCountryCode, interval = false) {
      let init = {};
      if(getSubCommunities() && getSelectedSubCommunity()){
        init.headers = {'ProdubSubcommunity':(getSelectedSubCommunity())}
      }
      if (interval) {
        this.props.setIsLoading(false);
      } else {
        this.props.setIsLoading(true);
      }

      return this.useAccessToken(init).then((init) => {
        return fetch(this.buildFullUrl(url, includeCountryCode), init)
          .then((response) => {
            if (response.status === 401) {
              this.props.history.push(loginPageUrl);
            }

            if (!response.ok) {
              throw new Error("Could not fetch data");
            }

            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
              return response.json();
            } else {
              return response;
            }
          })
          .then((data) => {
            if (!interval) {
              this.props.setIsLoading(false);
            }
            return data;
          });
      });
    }

    tokenPost(body, onSuccess) {
      let init = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      this.props.setIsLoading(true);
      this.postPut(process.env.REACT_APP_BASE_URL + process.env.REACT_APP_TOKEN_PATH, body, init, onSuccess);
    }

    getImageAsBlob(imageUrl, onSuccess) {
      fetch(imageUrl, {
        responseType: "blob",
      })
        .then((response) => {
          return response.blob();
        })
        .then(function(responseAsBlob) {
          if (onSuccess) {
            onSuccess(responseAsBlob);
          }
        });
    }

    postPut(url, body, optionalInit, onSuccess, interval) {

      let defaultInit = {
        body: body,
        cache: "no-cache",
        credentials: "same-origin",
        mode: "cors",
        redirect: "follow",
        referrer: "no-referrer",
      };
      if(getSubCommunities() && getSelectedSubCommunity()){
        defaultInit.headers = {'ProdubSubcommunity':(getSelectedSubCommunity())}
      }



      let init = { ...defaultInit, ...optionalInit };

      fetch(url, init)
        .then((response) => {
          if (response.status === 401) {
            this.props.history.push(loginPageUrl);
          }
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json();
          } else {
            return response;
          }
        })
        .then((data) => {
          if (data.ExceptionMessage) {
            alert(data.ExceptionMessage);
          } else {
            if (onSuccess) {
              onSuccess(data);
            }
          }
          this.props.setIsLoading(false);
          this.props.setSearchLoader(false);
        })
        .catch((error) => {
          this.removeLoaderMask(interval);
        });
    }

    buildFullUrl(url, includeCountryCode) {
      return includeCountryCode
        ? process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_PATH + getSelectedCountryCode() + "/" + url
        : process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_PATH + url;
    }

    useAccessToken(init) {
      var that = this;
      var promise = new Promise(function(resolve, reject) {
        if (!init.headers) {
          init.headers = {};
        }

        if (isTokenExpired()) {
          that.attemptRefreshToken(() => {
            init.headers.authorization = "bearer " + localStorage.getItem("access_token");
            resolve(init);
          });
        } else {
          init.headers.authorization = "bearer " + localStorage.getItem("access_token");
          resolve(init);
        }
      });

      return promise;
    }

    attemptRefreshToken(callback) {
      var dataToSend = buildQueryStringForRefreshingToken();
      if (!dataToSend) {
        this.props.history.push(loginPageUrl);
        return;
      }

      this.tokenPost(dataToSend, (response) => {
        if (response.error) {
          clearStoredTokenParams();
          this.props.history.push(loginPageUrl);
        } else {
          storeTokenParams(response);
          if (callback) {
            callback();
          }
        }
      });
    }
    removeLoaderMask(interval){
      interval = true;
      if(document.querySelector('.loader-mask')){
        let mask = document.querySelector('.loader-mask');
        mask.style.zIndex = '';
        mask.style.opacity = '';

        alert('Sorry, something went wrong');
         //this.props.history.push('/');
      }

    }

    render() {
      let props = omit(this.props, ["setIsLoading", "setSearchLoader"]);

      return (
        <WrappedComponent
          ajax={{
            post: this.post,
            put: this.put,
            get: this.get,
            getPromise: this.getPromise,
            delete: this.delete,
            deletePromise: this.deletePromise,
            tokenPost: this.tokenPost,
            getImageAsBlob: this.getImageAsBlob,
          }}
          {...props}
        />
      );
    }
  };
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({
  setIsLoading(isLoading) {
    dispatch(setIsLoading(isLoading));
  },
  setSearchLoader(searchLoader) {
    dispatch(setSearchLoader(searchLoader));
  },
});
export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  WithAjax
);
